import React, { Suspense } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { useSubheader } from "../../../_metronic/layout";
import { LayoutSplashScreen, ContentRoute } from "../../../_metronic/layout";
import List from "./List"
import { View } from "./View";
import { connect } from 'react-redux';

function DispenseFromAssosiate (props) {
  const user_type = props && props.me && props.me.user_type
  var title
  if (user_type == "PHARMACIST") {
    title = "Medicine Dispense Requests"
  }
  if (user_type == "LABORATORY") {
    title = "Doctor's Test Requests"
  }

  const suhbeader = useSubheader();
  suhbeader.setTitle(title);

  return (
    <Switch>
      <Redirect
        exact={true}
        from="/assosiate-dispense"
        to="/assosiate-dispense/list"
      />
      <ContentRoute from="/assosiate-dispense/list" component={List} />
      <ContentRoute from="/assosiate-dispense/view" component={View} />
    </Switch>
  );
};
const mapStateToProps = function (state) {
  return {
    me: state.me,
  }
}

export default connect(mapStateToProps)(DispenseFromAssosiate);
